import { useEffect, useState } from "react";
import { Button, Tab } from "semantic-ui-react";
import "./styles.module.css";
import styles from "./styles.module.css";
import { useNavigate } from "react-router-dom";
import AllUsers from "./lists/AllUsers";
import { FilterModal } from "../../../app/common/helpers";
import { ReactComponent as SvgSearchIcon } from "../../../assets/searchIcon.svg";
import { ReactComponent as PlusCircle } from "../../../assets/plusCircle.svg";
import { useStore } from "../../../app/stores/store";
import TablePlaceholder from "../products/tables/TablePlaceholder";
import Loading from "../../../app/layout/Loading";
import { observer } from "mobx-react-lite";

const UsersIndex = () => {
  const [currentFilter, setCurrentFilter] = useState({ value: "", code: 0 });
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();
  const { userStore } = useStore();
  const {
    getVendorUsers,
    loadingInitial,
    userList,
    activeUserList,
    inactiveUserList,
    updateUserRole,
    rolesLoading,
  } = userStore;

  const handleSearchChange = (
    e: React.ChangeEvent<HTMLInputElement>, 
  ) => {
    // setCurrentPage(1); // Reset the page to 1
    setSearchTerm(e.target.value); // Update the search term
    if(e.target.value){
      getVendorUsers(searchTerm);
    }else {
      getVendorUsers("");
    }
  };

  const filteredUsersList = userList
    .filter((val) => {
      if (searchTerm === "") {
        return val;
      } else if (
        val.name != null
        // val.name.toLowerCase().includes(searchTerm.toLowerCase())
      ) {
        return val;
      } else {
        return null;
      }
    })
    .filter((fil) => {
      if (currentFilter.code >= 100) {
        return fil;
      } else if (currentFilter.code === 2) {
        return (
          fil.status === "Active" ||
          fil.status === "active" ||
          fil.roleName === "Owner"
        );
      } else if (currentFilter.code === 3) {
        return (
          fil.status !== "Active" &&
          fil.status !== "active" &&
          fil.roleName !== "Owner"
        );
      }
      return fil;
    })
    .sort(function (x, y) {
      if (currentFilter.value === "Newest to Oldest") {
        let b = new Date(x.dateCreated.split("|")[0]).getDate(),
          a = new Date(y.dateCreated.split("|")[0]).getDate();
        return a === b ? 0 : a > b ? 1 : -1;
      } else if (currentFilter.value === "Oldest to Newest") {
        let a = new Date(x.dateCreated.split("|")[0]).getDate(),
          b = new Date(y.dateCreated.split("|")[0]).getDate();
        return a === b ? 0 : a > b ? 1 : -1;
      } else {
        let a = new Date(x.dateCreated.split("|")[0]).getDate(),
          b = new Date(y.dateCreated.split("|")[0]).getDate();

        return a === b ? 0 : a > b ? 1 : -1;
      }
    });

  const filteredActiveUsersList = activeUserList
    .filter((val) => {
      if (searchTerm === "") {
        return val;
      } else if (
        val.name != null 
      ) {
        return val;
      } else {
        return null;
      }
    })
    .sort(function (x, y) {
      if (currentFilter.value === "Newest to Oldest") {
        let b = new Date(x.dateCreated.split("|")[0]).getDate(),
          a = new Date(y.dateCreated.split("|")[0]).getDate();
        return a === b ? 0 : a > b ? 1 : -1;
      } else if (currentFilter.value === "Oldest to Newest") {
        let a = new Date(x.dateCreated.split("|")[0]).getDate(),
          b = new Date(y.dateCreated.split("|")[0]).getDate();
        return a === b ? 0 : a > b ? 1 : -1;
      } else {
        let a = new Date(x.dateCreated.split("|")[0]).getDate(),
          b = new Date(y.dateCreated.split("|")[0]).getDate();

        return a === b ? 0 : a > b ? 1 : -1;
      }
    });

  const filteredInActiveUsersList = inactiveUserList
    .filter((val) => {
      if (searchTerm === "") {
        return val;
      } else if (
        val.name != null &&
        val.name.toLowerCase().includes(searchTerm.toLowerCase())
      ) {
        return val;
      } else {
        return null;
      }
    })
    .sort(function (x, y) {
      if (currentFilter.value === "Newest to Oldest") {
        let b = new Date(x.dateCreated.split("|")[0]).getDate(),
          a = new Date(y.dateCreated.split("|")[0]).getDate();
        return a === b ? 0 : a > b ? 1 : -1;
      } else if (currentFilter.value === "Oldest to Newest") {
        let a = new Date(x.dateCreated.split("|")[0]).getDate(),
          b = new Date(y.dateCreated.split("|")[0]).getDate();
        return a === b ? 0 : a > b ? 1 : -1;
      } else {
        let a = new Date(x.dateCreated.split("|")[0]).getDate(),
          b = new Date(y.dateCreated.split("|")[0]).getDate();

        return a === b ? 0 : a > b ? 1 : -1;
      }
    });
  const panes = [
    {
      menuItem: "All Users",
      render: () =>
        loadingInitial === "loading" ? (
          <TablePlaceholder />
        ) : (
          <AllUsers
            userList={filteredUsersList}
            updateUserRole={updateUserRole}
            rolesLoading={rolesLoading}
          />
        ),
    },
    {
      menuItem: "Inactive",
      render: () =>
        loadingInitial === "loading" ? (
          <TablePlaceholder />
        ) : (
          <AllUsers
            userList={filteredInActiveUsersList}
            updateUserRole={updateUserRole}
            rolesLoading={rolesLoading}
          />
        ),
    },
    {
      menuItem: "Active",
      render: () =>
        loadingInitial === "loading" ? (
          <TablePlaceholder />
        ) : (
          <AllUsers
            userList={filteredActiveUsersList}
            updateUserRole={updateUserRole}
            rolesLoading={rolesLoading}
          />
        ),
    },
  ];
  const statuses = [
    { name: "Newest to Oldest", code: 0 },
    { name: "Oldest to Newest", code: 1 },
    { name: "Active", code: 2 },
    { name: "Inactive", code: 3 },
  ];

  useEffect(() => {
    getVendorUsers(searchTerm);
  }, [getVendorUsers]);

  return (
    <div className={styles.page}>
      {(loadingInitial === "loading" || rolesLoading === "loading") && (
        <Loading />
      )}
      <div className={styles.header}>
        Users
        <div className={styles.searchAndFilter}>
          <div>
            <div className={`${styles.hassearch}`}>
              {/* <span className="fa fa-search form-control-feedback"></span> */}
              <SvgSearchIcon className={styles.formcontrolfeedback} />
              <input
                type="text"
                className={styles.formcontrol}
                placeholder="Search Users"
                onChange={(e) => {
                  handleSearchChange(e);
                }}
              />
            </div>
          </div>
          <FilterModal
            options={[
              ...[...statuses].map((status, index) => ({
                code: index,
                value: status.name,
              })),
              { value: "None", code: 100 },
            ]}
            onSelect={(e) => setCurrentFilter({ value: e.value, code: e.code })}
            selected={currentFilter.code}
          />
          <Button
            positive
            className={styles.activate}
            onClick={() => navigate("/vendor/users/new-user")}
          >
            <div className={styles.positive}>
              <span>New User</span>
              <PlusCircle />
            </div>
          </Button>
        </div>
      </div>

      <div className={styles.tableSection}>
        <div className="section">
          <Tab menu={{ secondary: true, pointing: true }} panes={panes} />
        </div>
      </div>
    </div>
  );
};

export default observer(UsersIndex);
